import * as _ from 'lodash-es';
import { AxiosInstance } from 'axios';
import { useEventBus } from '@vueuse/core';
import { ResourceConfig } from '@repo/core/resources';
import { HeaderConstants, MessageConstants } from '@repo/core/constants';
import { useAuthService } from '@repo/core/security';

export const setRequestInterceptor = (instance: AxiosInstance, prefix = 'Bearer') => {
  instance.interceptors.request.use(
    async (config) => {
      config.headers = config.headers ?? {};

      const authService = useAuthService();
      const token = await authService.getToken();
      if (token) {
        config.headers.Authorization = `${prefix} ${token}`;
      }

      if (sessionStorage.practiceId) {
        config.headers[HeaderConstants.PracticeId] = sessionStorage.practiceId;
      }
      if (sessionStorage.clientId) {
        config.headers[HeaderConstants.ClientId] = sessionStorage.clientId;
      }
      if (sessionStorage.entityId) {
        config.headers[HeaderConstants.EntityId] = sessionStorage.entityId;
      }
      if (sessionStorage.supportAccessRequestId) {
        config.headers[HeaderConstants.SupportAccessRequestId] = sessionStorage.supportAccessRequestId;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export const setResponseInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => {
      // console.log(
      //   `${response.config.baseURL}${response.config.url}, status: ${response.status}, method: ${response.config.method}`
      // );
      const eventBus = useEventBus('eventBus');
      if (
        (_.toLower(response.config.method) === 'post' || _.toLower(response.config.method) === 'delete') &&
        _.includes(response.config.baseURL, ResourceConfig.serverBase)
      ) {
        // strip the querystring (e.g. ?$auditAction=...) before deriving the type,
        // otherwise the audit params get appended to the type and the 'save' broadcast
        // no longer matches consumers like WorkingTrialBalanceView (type === 'cashbookEntries').
        // Mirrors the Angular httpInterceptor (dxcloud.webui) which uses .split('?')[0].
        const path = _.split(_.replace(response.config.url ?? '', ResourceConfig.serverBase, ''), '?')[0];
        const parts = _.split(path, '/');
        if (parts.length > 0) {
          const type = parts[0];
          const data = response.data;
          if (!response.config.headers['noBroadcast']) {
            eventBus.emit('save', { type: type, data: data });
          }
          console.log('Save: ', data);
        }
      }

      return response;
    },
    async (error) => {
      const response = error.response;
      if (response) {
        if (error.config.responseType === 'blob') {
          const text = await error.response.data.text();
          response.data = JSON.parse(text);
        }

        if (response?.status === 400) {
          if (response.data.message) {
            response.data.message = _.replace(response.data.message, /\r\n|\r|\n/g, '<br />');
          }
          if (response.data.errors) {
            const data = response.data;
            for (let i = 0; i < response.data.errors.length; i++) {
              if (_.isArray(data) && data[i]) data[i].$errors = response.data.errors[i];
              else data.$errors = response.data.errors[i];
            }
          }
        }

        // HACK: Temp fix to sort out 401 errors with refresh tokens
        /*if (response?.status === 401) {
          console.error('401 response status', response);

          const authService = useAuthService();
          await authService.storeUser(null);

          const isIFrame = window.self !== window.top;
          if (isIFrame) {
            const target = window.parent;
            const targetOrigin = ResourceConfig.webAngularUrl;
            target.postMessage({ event: MessageConstants.login }, targetOrigin);
          } else {
            await authService.login();
          }
        }*/
      }
      return Promise.reject(error);
    }
  );
};
